import { ACTIONS, KEYS } from "../../_config";
import { ActionExtended } from "../../_config/interfaces/interfaces";

export interface CustomerFilters {
    keyword?: string;
    city?: string;
    createdDateFrom?: Date | null;
    createdDateTo?: Date | null;
    locationIds?: any[];
    groupIds?: any[];
}

export interface CustomerReducer {
    customers: any[] | null;
    customerGroups: any[] | null;
    filters: CustomerFilters | null;
}

const initialState: CustomerReducer = {
    customers: null,
    customerGroups: null,
    filters: null,
};

const customerReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.CUSTOMERS.LIST_CUSTOMER_GROUPS:
            return {
                ...state,
                customerGroups: action.payload,
            };
        
        case ACTIONS.CUSTOMERS.SET_CUSTOMER_FILTERS:
            return {
                ...state,
                filters: action.payload,
            };
        
        case ACTIONS.CUSTOMERS.CLEAR_CUSTOMER_FILTERS:
            return {
                ...state,
                filters: null,
            };

        default:
            return state;
    }
};

export default customerReducer;
